/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const materialType = {
  /**
   *  AJAX-获取分类列表
   *  @param parentId 大类 0 小类 上级大类Id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listMaterialType(parentId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_MATERIAL_TYPE,
      {
        parentId: parentId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加分类
   *  @param parentId 大类 0 小类 上级大类Id
   * @param typeName
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addMaterialType(parentId, typeName, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_MATERIAL_TYPE,
      {
        parentId: parentId,
        typeName: typeName,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除分类
   * @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  removeMaterialType(id, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.REMOVE_MATERIAL_TYPE,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

}

export default materialType;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-material-type.js